import { Directive, OnInit, Input, OnDestroy } from "@angular/core";
import { ViewportScroller } from "@angular/common";
import { CssSelector } from "@angular/compiler";

@Directive({
	selector: "[appScrollTo]",
})
export class ScrollToDirective implements OnInit, OnDestroy {
	@Input() appScrollTo: CssSelector;
	@Input() appScrollBack: boolean;

	previousPosition: [number, number];

	constructor(private viewportScroller: ViewportScroller) {}

	ngOnInit() {
		this.previousPosition = this.viewportScroller.getScrollPosition();
		this.viewportScroller.scrollToPosition([0, 0]);
	}

	ngOnDestroy() {
		if (this.appScrollBack && this.previousPosition) {
			this.viewportScroller.scrollToPosition(this.previousPosition);
		}
	}
}
